module.exports = __webpack_public_path__ + "img/TK.e5fa89ea.svg";